import * as React from "react";
import {Ref} from "react";
import {activateUser} from "../../actions/authActions";
import * as toastr from "toastr";
import history from "../../config/history";
import './userActivation.css'

const PASSWORD_LENGTH_MIN = 4;
const PASSWORD_LENGTH_MAX = 64;

export default function UserActivation(props: any) {
    const passwordRef: Ref<HTMLInputElement> = React.createRef();
    const rePasswordRef: Ref<HTMLInputElement> = React.createRef();

    const onSubmit = () => {
        if (!validFields()) {
            return;
        }
        activateUser(retrieveUserActivationKey(), passwordRef.current.value)
        .then(() => {
            history.push(`${process.env.ENV_PREFIX}/login`);
        })
    };

    const validFields = (): boolean => {
        if (passwordRef.current.value.length < PASSWORD_LENGTH_MIN || passwordRef.current.value.length > PASSWORD_LENGTH_MAX) {
            toastr.error(`The password length should be between ${PASSWORD_LENGTH_MIN} and ${PASSWORD_LENGTH_MAX} symbols.`);
            return false;
        }
        if (passwordRef.current.value !== rePasswordRef.current.value) {
            toastr.error("Passwords does not match.");
            return false;
        }
        return true;
    };

    const retrieveUserActivationKey = (): string => {
        if (typeof window.location === 'undefined' || typeof window.location.search === 'undefined' || window.location.search === null) {
            return "";
        }
        let urlKey = window.location.search;
        let index = urlKey.lastIndexOf('=');
        if (index < 0) {
            return "";
        }
        return urlKey.substr(index + 1, urlKey.length);
    };

    const onEnter = (e) => {
        if (e.which === 13) {
            onSubmit();
        }
    };

    return (
        <div onKeyDown={onEnter} id='user-activate-wrapper' className={'background-gradient'} style={{height: '100vh'}}>
            <div className={'app-wrapper-image'}/>
            <div className="middle-box text-center loginscreen animated fadeInDown">
                <div className={'user-activate-container'}>
                    <h1 style={{fontSize: 30, color: '#adadad', marginTop: 0}}>Activate User</h1>
                    <div className="form-group">
                        <input ref={passwordRef} style={{borderRadius: 3}} type="password" className="form-control new-design"
                               placeholder="Password"/>
                    </div>
                    <div className="form-group">
                        <input ref={rePasswordRef} style={{borderRadius: 3}}
                               type="password" className="form-control new-design" placeholder="Repeat Password"/>
                    </div>
                    <button onClick={onSubmit} style={{width: "100%"}} className="btn new-style-btn">Submit</button>
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/components/UserActivation/UserActivation.tsx